<script lang="ts" setup>
  const props = withDefaults(
    defineProps<{
      color?: string
      variant?: string
      margin?: string
    }>(),
    {
      color: 'var(--color-stroke-medium)',
      variant: 'dotted',
      margin: '12px 0'
    }
  )
</script>

<template>
  <hr :class="variant === 'solid' ? 'solid' : 'dotted'" />
</template>

<style lang="scss" scoped>
  hr {
    padding: 2px 0;
    background-position: bottom;
    background-size:
      14px 4px,
      4px 14px;
    background-repeat: repeat-x;
    margin: v-bind(margin);
  }

  .dotted {
    background-image: radial-gradient(circle at 1px, v-bind('props.color') 1px, rgba(255, 255, 255, 0) 1px);
  }

  .solid {
    border-bottom: 1px solid v-bind('props.color');
  }
</style>
